import "./Login.less";

import React, { Component } from "react";
import { Link } from "react-router-dom";
import { translate } from "react-i18next";
import queryString from "query-string";
import { withRouter } from 'react-router';

import logo from "../../assets/images/plantyn_logo.svg";

import config from "../../config";

import $ from "jquery";
import { getLocale } from "../PlatformSwitch/PlatformSwitch";

class Login extends Component {
	state = {
		email: "",
		password: "",
		showError: false
	};

	constructor(props) {
		super(props);		

		const currentQuery = queryString.parse(window.location.search);

		if (config.user) {
			const isBaO = config.user.profile.isbao === "True";
			const isSO = config.user.profile.isso === "True";

			if (isSO && isBaO) {
				if (!currentQuery.bothaccess) {
                    this.props.history.push('/login?bothaccess=true');
                }
			}
			else if (isBaO) {
                window.location.href = '/Choice/BaO';
            }
			else if (isSO) {
                window.location.href = '/Choice/SO';
            }
			else {
                this.props.history.push('/setup');
            }
		}
	}

	componentDidMount() {
		const localPlatform = localStorage.getItem('selected-platform')
		const queryParams = new URLSearchParams(window.location.search)
		const bothAccess = queryParams.get('bothaccess')
		const idp = queryParams.get('idp')
		if(localPlatform !== 'primary' && bothAccess !== 'true' && idp === null) {
			this.props.history.push('/');
		}
	}

	render() {
		const currentQuery = queryString.parse(window.location.search);

		if (config.user && !currentQuery.bothaccess) return <div/>;

		const t = this.props.t;

		const returnUrl = currentQuery.returnUrl;
		const query = queryString.stringify({ returnUrl });

		const locale = getLocale()

		const onSEPLinkClick = () => {
			localStorage.removeItem('selected-platform')
      		localStorage.removeItem('show-platform-switch')
		}

		return (
			<div className="login">
				<p className="header">{t("loginTitle")}</p>

				<form onSubmit={this.handleSubmitClick} noValidate>
					<input type="email" value={this.state.email} onChange={this.handleEmailChange} placeholder={t("emailPlaceholder")} />
					<input type="password" value={this.state.password} name="password" id="password" onChange={this.handlePasswordChange} placeholder={t("passwordPlaceholder")} />
					{this.state.showError && <p className="error">{this.state.errorMessage}</p>}
					<button type="submit" className="primarybtn">
						{t("login")}
					</button>
				</form>

				<Link to={"/forgotten?" + query} className="forgot-password">{t("forgotPassword")}</Link>
				<div className="separator-small"/>
				<a href={`https://apps.plantyn.com/se${locale ? '?lng=' + locale : ''}`} className="sep-link" onClick={onSEPLinkClick}>
					{t("SEPLogin")}
				</a>

				<div className="separator">
					<hr />
					<p>{t("common:or")}</p>
				</div>
				<p className="login-with">{t("loginWithAnother")}</p>
				<button className="loginbtn smartschool" onClick={() => this.providerClickHandler("Smartschool")}>
					<span>Smartschool</span>
				</button>
				<div className="login_button_holder">
					<button className="loginbtn facebook" onClick={() => this.providerClickHandler("Facebook")}><span /></button>
					<button className="loginbtn google" onClick={() => this.providerClickHandler("Google")}><span /></button>
					<button className="loginbtn microsoft" onClick={() => this.providerClickHandler("Microsoft")}><span /></button>					
				</div>
				<p className="login_whataboutknooppunt">
					<a href="/profile/knooppunt">{t("whatAboutKnooppunt")}</a>
				</p>				
				<div className="separator filled">
					<hr />
				</div>
				<div className="register_cta">
					<p>
						{t("noAccount")}
						<Link to={"/registration?" + query}>{t("registerNow")}</Link>
					</p>
				</div>
				<img className="plantyn_logo" src={logo} alt="" />
			</div>
		);
	}

	handleEmailChange = event => {
		this.setState({ email: event.target.value });
	};

	handlePasswordChange = event => {
		this.setState({ password: event.target.value });
	};

	providerClickHandler(provider) {
		const currentQuery = queryString.parse(this.props.location.search);
		const returnUrl = currentQuery.returnUrl;
		const clientId = config.identityServer.clientId;
		const culture = config.language + "-BE";

		const query = queryString.stringify({ provider, returnUrl, clientId, culture });
		window.location = `${config.identityServer.baseUrl}/Portal/LogInExternal?${query}`;
	}

	handleSubmitClick = e => {
		const t = this.props.t;

		e.preventDefault();

		if ((this.state.email || '').trim().length === 0) {
			this.setState({ showError: true, errorMessage: t('emailAddressRequired'), mailAlreadyTaken: false });
			return;
		}

		if ((this.state.password || '').trim().length === 0) {
			this.setState({ showError: true, errorMessage: t('passwordRequired'), mailAlreadyTaken: false });
			return;
		}
		
		this.setState({ showError: false, errorMessage: '' });

		const currentQuery = queryString.parse(this.props.location.search);

		$.post(`${config.identityServer.baseUrl}/Portal/ValidateLogIn`, {
			username: this.state.email,
			password: this.state.password,
			clientId: currentQuery.clientId || config.identityServer.clientId,
			culture: config.language + "-BE"
		},
		result => {
			if (!result.success) {
				if (result.notActivated)
					this.setState({ showError: true, errorMessage: t('loginErrorNotActivated') });
				else if (result.foundAccount)				
					this.setState({ showError: true, errorMessage: t('loginErrorFoundAccount', { provider: t(result.foundAccount.toLowerCase()) }) });
				else	
					this.setState({ showError: true, errorMessage: t('loginError') });
			}
			else {
				const url = `${config.identityServer.baseUrl}/Portal/LogIn`

				$($('<form method="POST" />').attr('action', url))
					.append($('<input type="hidden" name="username">').val(this.state.email))
					.append($('<input type="hidden" name="password">').val(this.state.password))
					.append($('<input type="hidden" name="clientId">').val(currentQuery.clientId || config.identityServer.clientId))
					.append($('<input type="hidden" name="culture">').val(config.language + "-BE"))
					.append($('<input type="hidden" name="returnUrl">').val(currentQuery.returnUrl))
					.appendTo(document.body)
					.submit();
			}
        })
		.fail(() => {
			this.setState({ showError: true, errorMessage: t('unexpectedError') });
		});
	}
}

const translateLogin = translate("login")(withRouter(Login));

export { translateLogin as Login };



// WEBPACK FOOTER //
// ./src/components/Login/Login.js